import { DATE_FORMAT_STR, formatDate, FormatterType, Hint, Icon, MatchUp, Typography } from "best-common-react";
import { Link } from "react-router";
import React from "react";
import CompleteConstants from "../../../../constants/CompleteConstants";
import { formatGameDateShort } from "../../../../util/TimeUtil";
import { BySeriesData, TotalData } from "./BySeriesTypes";

const Zero = ({ subrow = false }: { subrow?: boolean }) => (
  <Typography elementStyles={{ color: "var(--color-on-surface-low)", weight: subrow ? "inherit" : "bold" }}>
    0
  </Typography>
);

export const GameDateFormatter = ({ row, subrow = false }: FormatterType<TotalData | BySeriesData>) => {
  const { homeTeam, awayTeam, venue, gameDate, toLink, location, seriesDescription, seriesDate } = row!;
  return (
    <div className="d-flex align-items-center min-w-0">
      <Link
        to={{
          pathname: toLink,
        }}
        state={{ previousLocation: location }}
        className="d-inline-flex align-items-center text-decoration-none"
        style={{ color: "inherit" }}
      >
        {subrow ? (
          <Typography elementStyles={{ width: "11.5rem" }} className="bcr-me-2">
            {formatGameDateShort(gameDate, venue.timeZone, false)}
          </Typography>
        ) : null}
        <MatchUp away={awayTeam} home={homeTeam} description={seriesDescription} />
        {!subrow && (
          <Typography className="bcr-ms-2" elementStyles={{ weight: "bold" }}>
            {seriesDate}
          </Typography>
        )}
      </Link>
    </div>
  );
};

export const CompleteInCompleteFormatter = ({
  value: { complete, incomplete, filter },
  row,
  subrow = false,
}: FormatterType<TotalData>) => {
  const { toLink, location } = row!;
  return (
    <div>
      <div className="d-flex bcr-gap-1 align-items-center" style={{ fontWeight: subrow ? "inherit" : "bold" }}>
        {incomplete === 0 ? (
          <Zero subrow={subrow} />
        ) : (
          <Link
            to={{
              pathname: toLink,
              search: `?${filter}&completeId=${CompleteConstants.INCOMPLETE_ID}`,
            }}
            state={{ previousLocation: location }}
          >
            {incomplete}
          </Link>
        )}
        <Typography elementStyles={{ color: "var(--color-on-surface-low)" }} elementType="span">
          {" "}
          |{" "}
        </Typography>
        {complete === 0 ? (
          <Zero subrow={subrow} />
        ) : (
          <Link
            to={{
              pathname: toLink,
              search: `?${filter}&completeId=${CompleteConstants.COMPLETE_ID}`,
            }}
            state={{ previousLocation: location }}
          >
            {complete}
          </Link>
        )}
      </div>
    </div>
  );
};

export const LinkFormatter = ({ value: { value, filter }, row, subrow = false }: FormatterType<TotalData>) => {
  const { toLink, location } = row!;
  return (
    <div>
      {value === 0 ? (
        <Zero subrow={subrow} />
      ) : (
        <Link
          to={{
            pathname: toLink,
            search: filter,
          }}
          state={{ previousLocation: location }}
        >
          <Typography elementStyles={{ weight: subrow ? "inherit" : "bold" }}>{value}</Typography>
        </Link>
      )}
    </div>
  );
};

export const EventChangeFormatter = ({ row, subrow = false }: FormatterType<TotalData>) => {
  const { status, rescheduledFrom } = row!;
  let message = "";
  if (status && status.codedGameState === "C") {
    message = "Cancelled";
  } else if (rescheduledFrom) {
    const date = formatDate(rescheduledFrom, DATE_FORMAT_STR);
    message = `Original date - ${date}`;
  } else if (status && status.codedGameState === "D") {
    message = "Postponed";
  }
  if (!subrow && message.length > 0) {
    return <Icon iconName="exclamation-circle" styles={{ color: "var(--color-surface-yellow-element)" }} />;
  } else {
    return <Hint>{message}</Hint>;
  }
};
